<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel">
    <!-- <app-banner-profile
      [image]="img1"
      [title]="title1"
      [customClasses]="class1"
    ></app-banner-profile> -->
    <div class="seller_approve_page">
      <!-- <app-main-heading [title]="title"></app-main-heading> -->
      <form class="businessValidationformBox mb-4">
        <div class="innerpageContent">
          <div class="row">
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Category </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Entity Type </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Reg Date </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div class="btnbx mt-5">
            <button type="button" class="btnThemeOutline blue me-3">
              Reset
            </button>
            <button class="btnTheme red" type="submit">Search</button>
          </div>
        </div>
      </form>
      <app-main-heading [title]="title"></app-main-heading>
      <div class="admin-table mt-5">
        <table class="adminPanel-table mb-5">
          <tr>
            <th></th>
            <th>Business Name</th>
            <th>Owner name</th>
            <th>Owner Type</th>
            <th>Category</th>
            <th>Business type</th>
            <th>STATUS</th>
            <th>Signup Date</th>
            <th>ACTIONS</th>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Lorem Ipsum</td>
            <td>Approved</td>
            <td class="padding">24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action">
                  <img src="../../../assets/images/eye-line.svg" alt="" />
                </div>
                <div class="action">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
